// components/ArticleList.tsx
import React, {  } from 'react';
import { Card, Rating } from '@mui/material';
import { TFunction } from 'next-i18next';
import Texto from '../../Texto';
import { textosPeque } from '@/constants/Dimens';
import { Comentario } from '@/objects/Articles';
import Boton from '../../Boton';
import { dateToTextTForm, obtenerHoraTForm } from '@/util/MagicDate';
import TituloDescripcion from '../../TituloDescripcion';
import TextoDescripcion from '../../TextoDescripcion';
import { black, primary, red, white } from '@/constants/Colors';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CommentIcon from '@mui/icons-material/Comment';
import StarIcon from '@mui/icons-material/Star';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useServices } from '@/context/ServicesProvider';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { AxiosResponse } from 'axios';
import TituloPrincipalH1 from '../../TituloPrincipalH1';
import { primeraLetraMayuscula } from '@/util/StringsUtil';
import { categorias_defecto } from '@/objects/Categorias';
import BadgeCustom from '../../Badge';
interface Props {
  t: TFunction;
  comentario: Comentario;
  onCargar: () => void;
}

const PRECISION = 0.5;

const RowPuntuarLibro: React.FC<Props> = ({ t, comentario, onCargar }) => {

  const { articulosQueries } = useServices();

  function puntuarUsuario() {
    /*
     mostrarAlerta({
       title: t('menu:secciones.puntuaciones.pulsa_para_puntuar'),
       content: <EditarPuntuacionLibro t={t} comentario={comentario} />,
       acceptText: t('common:opciones.cancelar'),
       onAccept: () => {
 
       }
     });
     */
  }

  function borrarComentario() {
    const datosUsuario = cargarDatosUsuario();
    articulosQueries?.borrarComentarioLibro(comentario.id, Number(datosUsuario?.id_user)).then((response: AxiosResponse<String>) => {
      if (response.status == 200) {
        window.location.href = "/dashboard/mis-puntuaciones-libros";
      }
    }
    ).catch((error: any) => {
    });
  }

  return (
    <Card
      style={{
        cursor: "pointer", display: 'flex', flexDirection: 'row',
        alignItems: 'center', justifyContent: 'space-between',
        width:
          window.innerWidth < 500 ? "94%" : "500px",
        padding: "20px",
        marginTop: "20px",
      }}>
      <article style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: "100%" }}>
        <section style={{ display: 'flex', flexDirection: 'column', marginLeft: "20px", width: "100%" }}>
          {comentario.titulo_libro &&
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: "center", alignContent: "center", marginBottom: "10px" }}>
              <TituloPrincipalH1 texto={primeraLetraMayuscula(comentario.titulo_libro)} />
            </div>
          }
          {comentario.categoria_libro &&
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', flexDirection: 'row', gap: '5px', alignItems: "center", alignContent: "center", marginBottom: "10px" }}>
              <BadgeCustom texto={t(categorias_defecto.filter(c => c.categoriaStringServer === comentario.categoria_libro)[0].titulo)} color={white} backgroundColor={primary} />
            </div>
          }
          {comentario.isbn &&
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: "center", alignContent: "center" }}>
              <TituloDescripcion color={black} icon={<LibraryBooksIcon />} >{t('contenido:libro.datos.isbn')}</TituloDescripcion>
              <TextoDescripcion>{comentario.isbn}</TextoDescripcion>
            </div>
          }
          {comentario.autor_libro &&
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: "center", alignContent: "center" }}>
              <TituloDescripcion color={black} icon={<LibraryBooksIcon />} >{t('contenido:libro.datos.autor')}</TituloDescripcion>
              <TextoDescripcion>{comentario.autor_libro}</TextoDescripcion>
            </div>
          }
          {comentario.editorial_libro &&
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: "center", alignContent: "center" }}>
              <TituloDescripcion color={black} icon={<LibraryBooksIcon />} >{t('contenido:libro.datos.editorial')}</TituloDescripcion>
              <TextoDescripcion>{comentario.editorial_libro}</TextoDescripcion>
            </div>
          }
          {comentario.puntuacion &&
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: "flex-start", marginTop: "10px", marginBottom: "10px" }}>
              <TituloDescripcion color={black} icon={<StarIcon />} >{t('contenido:subir-libro.puntuacion_libro')}</TituloDescripcion>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Rating name="controlled" value={comentario.puntuacion} readOnly={true}
                  precision={PRECISION} size={"large"} />
              </div>
            </div>
          }
          {comentario.comentario &&
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: "flex-start", marginBottom: "10px" }}>
              <TituloDescripcion color={black} icon={<CommentIcon />} >{t('contenido:subir-libro.comentario_libro')}</TituloDescripcion>
              <TextoDescripcion>{comentario.comentario}</TextoDescripcion>
            </div>
          }
          <Texto fontSize={textosPeque}>{dateToTextTForm(comentario.timestamp, t) + " " + obtenerHoraTForm(comentario.timestamp)}</Texto>
          <div style={{ display: 'flex', flexDirection: 'column', alignContent: "flex-end", alignItems: "flex-end", width: "100%", marginTop: "10px" }}>
            <Boton color={red} startIcon={<DeleteForeverIcon />} texto={t("common:opciones.borrar")} onClick={borrarComentario} />
            {/*<Boton fullWidth startIcon={<ReviewsIcon />} texto={t("contenido:subir-libro.editar_resena")} onClick={puntuarUsuario} />*/}
          </div>
        </section>
      </article>
    </Card>
  );
};

export default RowPuntuarLibro;
